import React, {Component, Fragment} from 'react';
import lightBulg from "./icons/24_light_bulb.svg";
import {Tooltip} from "../tooltip/Tooltip";
import Onboarding from "../popup/OnboardingPopop.component";
import _ from "lodash";
import {launchDarkly} from "utils/launchDarkly";
import {ICON_SIZE} from "components/common/constants.ts";
import {Sparkles} from "lucide-react";
import {Button, ButtonType} from "components/common/Button.component.tsx";

const showOnboardingEvent = "showOnboardingEvent";
const closeOnboardingEvent = "closeOnboardingEvent"
const oldOnboardingPopup = localStorage.getItem('onboarding/popup/hideDetachOnboarding');

export class OnboardingTaskDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOnboardingPopup: false,
            showOnboardingTooltip: false,
            showNotification: false
        };
        this.onboardingIcon = React.createRef();
        this.showOnboarding = this.showOnboarding.bind(this);
        this.closeOnboarding = this.closeOnboarding.bind(this);
        this.dispatchOnboarding = this.dispatchOnboarding.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.dismiss = this.dismiss.bind(this);

        this.showAIAssistant = launchDarkly.userClient?.variation("enable-ai-assistant", false);
    }

    componentDidMount() {
        //clear old cookies
        if (oldOnboardingPopup)
            localStorage.removeItem('onboarding/popup/hideDetachOnboarding');
        if (this.showAIAssistant)
            this.showOnboarding();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    showOnboarding() {
        const onboardingPopup = localStorage.getItem('onboarding/popup/hideAiAssistantOnboarding');
        if (onboardingPopup === 'true') {
            return;
        }
        this.dispatchOnboarding();
    }

    dispatchOnboarding() {
        this.setState({
            showOnboardingTooltip: true
        }, () => {
            this.onboardingIcon.current?.dispatchEvent(new Event(showOnboardingEvent));
        })
    }

    closeOnboarding() {
        this.setState({showOnboardingPopup: false, showOnboardingTooltip: false, showNotification: false});
        this.onboardingIcon.current?.dispatchEvent(new Event(closeOnboardingEvent));
        localStorage.setItem('onboarding/popup/hideAiAssistantOnboarding', 'true');
    }

    handleClickOutside = (event) => {
        if (
            this.state.showOnboardingTooltip &&
            this.onboardingIcon.current &&
            !this.onboardingIcon.current.contains(event.target)
        ) {
            this.closeOnboarding();
        }
    };

    dismiss() {
        this.setState({
            showNotification: false,
            showOnboardingTooltip: false
        })
        this.onboardingIcon.current?.dispatchEvent(new Event(closeOnboardingEvent));
    }


    render() {

        const content = _.times(1, (index) => {
            let time = index + 1;
            return <p>{this.props.translate("menu.onboarding.content" + time)}</p>
        });

        return (
            <Fragment>
                {this.showAIAssistant &&
                    <li className={"icon " + (this.state.showNotification ? "attention" : "")}
                        data-for={"onboarding-tooltip"} data-tip ref={this.onboardingIcon}>
                        <a className="button-help" href="#"
                           onClick={this.state.showOnboardingTooltip ? this.closeOnboarding : this.dispatchOnboarding}>
                            <img alt={"light bulb"} src={lightBulg} className={"appicon vismaicon-dynamic border-0"}/>
                        </a>
                    </li>
                }

                {this.state.showOnboardingTooltip &&
                    <Tooltip
                        place="bottom"
                        id={"onboarding-tooltip"}
                        event={showOnboardingEvent}
                        eventOff={closeOnboardingEvent}
                        borderClass={"border-onboarding-tooltip"}
                        content={() => {
                            return <div className={"d-flex onboarding__tooltip__content rounded-4"}>

                                <Sparkles className="pull-left onboarding__title__image" size={ICON_SIZE.XLARGE}/>

                                <div className={"pull-right onboarding__tooltip__body ml-12"}>
                                    <h3 className={"d-flex my-3"}>
                                        <strong>
                                            {this.props.translate("menu.onboarding.title")}
                                        </strong>
                                    </h3>
                                    <div>
                                        {content}
                                    </div>

                                    <div className={"mt-24 d-flex justify-content-between"}
                                         style={{lineHeight: "36px"}}>
                                        <Button type={ButtonType.SECONDARY}
                                                tabIndex={0}
                                                onClick={this.closeOnboarding}
                                                text={this.props.translate("menu.onboarding.ok")}
                                        />
                                    </div>
                                </div>
                            </div>
                        }}
                    />
                }

                {this.state.showOnboardingPopup &&
                    <Onboarding loggedInData={this.props.loggedInData}
                                userData={this.props.userData}
                                closeCallback={this.closeOnboarding}/>
                }
            </Fragment>
        )
    }
}

export default OnboardingTaskDetails;
